import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { OrderSummaryResponse } from '../../model/ordersummaryresponse';

import { SortableColumn } from '../../model/sort/sortable-column';
import { ReportsService } from '../../../services/reports.service';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../../model/user-data';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { UsersDataResponse } from '../../model/users-data-response';
import { PdfViewerComponent } from '../../pdf-viewer/pdf-viewer.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonPdfComponent } from '../../common-pdf/common-pdf.component';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { SelectionChange } from '@angular/cdk/collections';
import { MatSelectChange } from '@angular/material/select';
import { Usersearch } from '../../model/usersearch';
import { DateAdapter } from '@angular/material/core';

@Component({
    selector: 'app-signed-oc-report',
    templateUrl: './signed-oc-report.component.html',
    styleUrls: ['./signed-oc-report.component.scss'],
    standalone: false
})
export class SignedOcReportComponent extends CommonPdfComponent implements OnInit,AfterViewInit {
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  orderSummary: OrderSummaryResponse[] = [];
  reportsForm: UntypedFormGroup;
  storeData:[]=[];
  storeNumber:string=null;
  dcNumber:number=null;
  sortableColumn:SortableColumn;
  filter:string='';
  minDate:Date=new Date();
  maxDate:Date=new Date();
  myControl = new UntypedFormControl();
  options:Usersearch[]=[];
  isDataloaded:boolean=true;
  filteredOptions: Observable<Usersearch[]>;
  dateTimeFormat:string='yyyy-MM-dd hh:mm:ss a';
  dateFormat:string='yyyy-MM-dd';
  storesOptions: string[] = [];
  filteredStoreOptions: Observable<string[]>;
  filteredUPN: Observable<Usersearch[]>;

  displayFn(storeData): string {
    return storeData ? storeData : '';
  }

  

  private _filter(name: string): Usersearch[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.fullName.toLowerCase().includes(filterValue));
  }
  constructor(private route: ActivatedRoute,private userservice:UserService,
    private reportsService: ReportsService, private fb: UntypedFormBuilder,private router:Router,protected dialog:MatDialog,
    private dateAdapter: DateAdapter<Date>) {
      super(dialog);
     }

  displayedColumns: string[] = ['purchaseOrder', 'poCreatedTime', 'receivedDate', 'poSignedBy'];
  dataSource: MatTableDataSource<OrderSummaryResponse>;
  userData:UserData;
  user:UsersDataResponse;
  

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  
  ngOnInit(): void {
    
  this.dataSource = new MatTableDataSource<OrderSummaryResponse>();
  this.userservice.getCurrentUser().subscribe(data=>{
    this.user=data;
    this.storesOptions=this.user.stores?this.user.stores.map(value => (value.storeNumber)):null;
    this.userData=data.userData;
    this.dateAdapter.setLocale(this.userData.language.toLowerCase()); 
    let lang=this.userData.language.toLowerCase();
    if(lang==='fr'){
      this.dateTimeFormat="medium";
     this.dateFormat="mediumDate"

    }
    if(this.userData.roleId<4){
    this.createFormDC();
    }else{
      this.createFormStore();
    }
    this.filteredOptions = this.reportsForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value.fullname))
    );

    this.filteredStoreOptions = this.reportsForm.controls.storeNumber.valueChanges
    .pipe(
      startWith(''),
      map(value => this.store_filter(value))
    );

  })
       
  }

  private store_filter(value: string): string[] {  
     const filterValue =  value !== null ? value.toLowerCase() : '';    
     if(value.charAt(0)==='0'){
      let options=this.storesOptions?this.storesOptions.filter(option => option.toLowerCase().startsWith(filterValue)):null; 
      options.sort((a,b) =>  (a > b ? 1 : -1));
      return options;

    }else{
      if(this.storesOptions){
       let options= this.storesOptions.filter(option => parseInt(option).toString().toLowerCase().startsWith(filterValue));
          options.sort((a,b) =>  (a > b ? 1 : -1));
      return options;
      }else{
        return null;
      }
     
    }

    //  let filterStores:any=[];
    //  if(filterValue!==''){
    //   filterStores=this.user.stores.filter(option => (option.storeNumber).toLowerCase().startsWith(filterValue));
    //  }else{
    //   filterStores=this.user.stores.filter(option => option);
    //  }
    //  filterStores.sort((a, b) => a.storeNumber.toLowerCase().localeCompare(b.storeNumber.toLowerCase()))
    //  return filterStores;
   }
 

  fromdateset(event){
    let fromDate = JSON.stringify(event.target.value)
    fromDate = fromDate.slice(1,11);
    this.reportsForm.controls.fromDate.setValue(fromDate);
    console.log(this.reportsForm.controls.fromDate.value);
  }

  filterValues(newValue){
    let upn=this.usersUpn.filter(e=>e.fullName)


  }

  
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort=this.sort;
   // this.getPOOrderData();
   
  //  this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
   
   
  }

usersUpn:Usersearch[]=[];
onchange(){
  this.reportsForm.controls.signedBy.reset();
  this.userservice.getUsersByStore(this.reportsForm.controls.storeNumber.value).subscribe(data=>{
  this.usersUpn=data;

    this.filteredUPN = this.reportsForm.controls.signedBy.valueChanges
    .pipe(
      startWith(''),
      map(value => this.upn_filter(value))
    );
  })
}

private upn_filter(value: string): Usersearch[] {
  const filterValue = value !== null ? value.toLowerCase() : '';
  let upn:any=[];
  if(filterValue!==''){
  upn=this.usersUpn.filter(option => option.fullName.toLowerCase().startsWith(filterValue));
  }else{
    upn=this.usersUpn.filter(option => option);
  }
upn.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()))
  return upn;
}

dcOnchange(){
  let dc=this.reportsForm.controls.dcNumber.value;
  this.storesOptions=this.user.stores?this.user.stores.filter(option => option.dcNumber===dc).map(value => (value.storeNumber)):null;  
  this.reportsForm.controls.storeNumber.setValue("");
  this.store_filter('');
}
  

  createFormDC() {
    this.reportsForm = this.fb.group({
      storeNumber: ['', Validators.required],
      dcNumber:['',Validators.required],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
      orderNumber: [''],
      signedBy: [''],
   
      
    });

  }

  

  createFormStore() {
    this.reportsForm = this.fb.group({
      storeNumber: ['', Validators.required],
      dcNumber:[null],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
      orderNumber: [''],
      signedBy: [''],
   
      
    });

  }

  sortData(sort: Sort) {   
    this.sortableColumn=new SortableColumn('','','');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);    
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }

  openReportBySeq(sequenceNumber){
  this.reportsService.getSignedResultsReports(sequenceNumber).subscribe((data:HttpResponse<any>)=>{
   console.log(data.headers.get('Content-Disposition'));
   let contentDispositionHeader= data.headers.get('Content-Disposition')
    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
    result.replace(/"/g, '');
    console.log(result);
    this.isDataloaded=true;
   let dialogData= {
    title: result,
      downloadFileName: result,
      downLoadFile:true
    }
    this.openReport(data.body,dialogData);
  //   this.dialog.open(PdfViewerComponent, {
  //     width: '100%',
  //     maxWidth: '90%',
  //     height: 'auto',
  //     data: {
  //       title: 'TEST',
  //       srcType: 'Binary',
  //       pdfData: new Blob([data], { type: 'application/pdf' }),
  //       downloadFileName: "Test.pdf",
  //       downLoadFile:true
  //     }
  //   });
   })
 
  }

  // _base64ToArrayBuffer(base64) {
	//   var binary_string = base64.replace(/\\n/g, '');
  //   binary_string =  window.atob(base64);
  //   var len = binary_string.length;
  //   var bytes = new Uint8Array( len );
  //   for (var i = 0; i < len; i++)        {
  //       bytes[i] = binary_string.charCodeAt(i);
  //   }
  //   return bytes.buffer;
  // }
  //let myStr:string = padLeft('123', '0', 6);  // '000123'
   
padLeft(text:string, padChar:string, size:number): string {
  return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
}

  getSignedResults(){
    this.dataSource = new MatTableDataSource<OrderSummaryResponse>();
    let fromDate = JSON.stringify(this.reportsForm.controls.fromDate.value)
    fromDate = fromDate.slice(1,11);
    let toDate = JSON.stringify(this.reportsForm.controls.toDate.value)
    toDate = toDate.slice(1,11);
    let esignedBy=this.reportsForm.controls.signedBy.value;
    let orderNumber=this.reportsForm.controls.orderNumber.value;
    if(esignedBy===undefined ||esignedBy===''){
      this.reportsForm.controls.signedBy.setValue(null);
    }
    if(orderNumber===undefined ||orderNumber===''){
      this.reportsForm.controls.orderNumber.setValue(null);
    }
    let sn=this.reportsForm.controls.storeNumber.value;
    if(sn.length<6){
      this.reportsForm.controls.storeNumber.setValue(this.padLeft(sn,'0',6));
    }
    this.reportsService.getSignedResults(this.reportsForm.value,fromDate,toDate).subscribe(data=>{
    this.dataSource=new MatTableDataSource<OrderSummaryResponse>(data);
    this.dataSource.paginator=this.paginator;
    this.dataSource.sort=this.sort;
    },(error:HttpErrorResponse)=>{
     
      if(error && error.status===404){
      let dialogData= {
        title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
        message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
       
      }
      this.dialog.open(ApproveDialogComponent,{
        data:dialogData,panelClass: 'my-class'
      });
    }
  })
  }


  // getPOOrderData() {
  //   if(this.reportsForm.value.storeNumber || this.reportsForm.value.dcNumber){
  //   this.dataSource=new MatTableDataSource();
    
  //   let requestPayload=this.getStatusValue();
  //   if(requestPayload.length>0){
  //   merge(this.sort.sortChange, this.paginator.page)
  //     .pipe(
  //       startWith({}),
  //       switchMap(() => {
  //         this.isLoadingResults = true;
  //         if(this.userData.roleId>3 || this.poSummaryForm.value.storeNumber){
  //         return this.poordersummaryservice!.getPOSummaryDataByStore(this.poSummaryForm.value.storeNumber,requestPayload.toString(),
  //           this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize);
  //         }else
  //         if(this.userData.roleId<4 || this.poSummaryForm.value.dcNumber ){
  //           return this.poordersummaryservice!.getPOSummaryDataByDC(parseInt(this.poSummaryForm.value.dcNumber),requestPayload.toString(),
  //           this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize);
  //         }
  //         }),
  //       map(data => {
  //         // Flip flag to show that loading has finished.
  //         this.isLoadingResults = false;
  //         this.isRateLimitReached = false;
  //         this.resultsLength = data.totalElements;

  //         return data.content;
  //       }),
  //       catchError(() => {
  //         this.isLoadingResults = false;
  //         // Catch if the GitHub API has reached its rate limit. Return empty data.
  //         this.isRateLimitReached = true;
  //         return observableOf([]);
  //       })
  //     ).subscribe(data => {
  //       this.dataSource=new MatTableDataSource(data);
  //       this.dataSource.sort = this.sort;
  //     });
  //   }
  // }
  // }

 

  
  
applyFilter(filterValue: string) {
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  this.filter=filterValue;
  this.dataSource.filter = filterValue;
}

advancedSearch(){
    console.log(this.filter);
    console.log(this.filter);
}

openPDF(data){
  this.dialog.open(PdfViewerComponent, {
    width: '100%',
    maxWidth: '90%',
    height: 'auto',
    // data: {
    //   title: 'Program Codes :'+ this.selectedTableRow.filename_pdf,
    //   srcType: 'Binary',
    //   pdfData: new Blob([this._base64ToArrayBuffer(data)], { type: 'application/pdf' }),
    //   downloadFileName: file,
    //   downLoadFile:false
    // }
  });
}


}
